import _ from 'lodash';
import isAcceptedOpenOrClosed from './isAcceptedOpenOrClosed';

function buildSentReferralsFetchFilters(filters, isCaseManager, fallbackStatus) {
  const formattedFilters = _.reduce(filters, (acc, f, key) => (
    f === 'all' ? acc : _.merge(acc, { [key]: f })
  ), {});
  formattedFilters.sent_by = _.uniq(
    _.map(formattedFilters.sent_by, (f) => f.split('-employee')[0]),
  );

  const status = formattedFilters.status || fallbackStatus;
  const openOrClosed = isAcceptedOpenOrClosed(status);

  if (isCaseManager && _.isEmpty(formattedFilters.referral_sender_users)) {
    formattedFilters.referral_sender_users = openOrClosed ? null : ['all'];
  }

  return { formattedFilters, status, openOrClosed };
}

export default buildSentReferralsFetchFilters;
